import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import ApiConnect from "../../../../Utils/ApiConnect";
import AnimatedNumber from "animated-number-react";
// import { format } from "date-fns";
import { connect } from "react-redux";
import { setOdersummary } from "../../../../redux/actions/Modules.Action";
class OrderSummary extends Component {
  constructor(props) {
    super(props);
    const today = new Date();

    // it gives yesterday date
    today.setDate(today.getDate() - 30);
  }

  FetchOrderSummary = async () => {
    try {
      ApiConnect.get(`POS/Orders/Details?location=bar`)
        .then((response) => {
          if (response.data) {
            this.props.setOdersummary(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (err) {
      console.log("error facing location:", err);
    }
  };
  componentDidMount = async () => {
    this.FetchOrderSummary();
  };
  formatValue = (value) => `${Number(value).toFixed()}`;
  render() {
    const OrderData = this.props.OrderDetails;
    return (
      <React.Fragment>
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Orders Summary</h4>
              <div className="dropdown bootstrap-select">
                <select className="form-control form-control-sm">
                  <option>Today</option>
                  <option>Yesterday</option>
                  <option>Last week</option>
                  <option>Last month</option>
                </select>{" "}
              </div>
            </div>
            <div className="card-body flexbox flex-justified">
              <div className="row p-3">
                <div className="col-sm-4">
                  <div className="card card-body text-purple border-purple b-1">
                    <div className="flexbox">
                      <span className="ti-wallet fs-40"></span>
                      <span className="fs-40">
                        <AnimatedNumber
                          value={OrderData.order || 0}
                          formatValue={this.formatValue}
                        />
                      </span>
                    </div>
                    <div className="text-right">Order Place</div>
                  </div>
                </div>

                <div className="col-sm-4">
                  <div className="card card-body bg-warning">
                    <div className="flexbox">
                      <span className="ti-wallet fs-40"></span>
                      <span className="fs-40">
                        <AnimatedNumber
                          value={OrderData.modify || 0}
                          formatValue={this.formatValue}
                        />
                      </span>
                    </div>
                    <div className="text-right">Modify</div>
                  </div>
                </div>

                <div className="col-sm-4 ">
                  <div className="card card-body bg-danger">
                    <div className="flexbox">
                      <span className="ti-wallet fs-40"></span>
                      <span className="fs-40">
                        <AnimatedNumber
                          value={OrderData.delete || 0}
                          formatValue={this.formatValue}
                        />
                      </span>
                    </div>
                    <div className="text-right">Canceled</div>
                  </div>
                </div>
              </div>
            </div>
            <Scrollbars style={{ height: "calc(100vh - 80ex)" }}>
              {OrderData ? (
                <table className="table table-striped table-hover">
                  <tbody>
                    {OrderData.map((kitchen, index) => (
                      <tr key={index}>
                        <td>
                          <ul className="">
                            {kitchen.product.map((prd, ind) => (
                              <li key={ind}>
                                {prd.name} X {prd.qty}
                              </li>
                            ))}
                          </ul>
                        </td>
                        <td className="text-muted w-80px">
                          {kitchen.table}
                          <span className={`badge badge-${kitchen.color}`}>
                            {kitchen.text}
                          </span>
                        </td>
                        <td className="text-success fw-500 w-90px">
                          {kitchen.date}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                ""
              )}
            </Scrollbars>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default connect(
  (state) => ({
    OrderDetails: state.Dashboard.orderSummary,
  }),
  { setOdersummary }
)(OrderSummary);
